import { PRODUCTS_VIEW_TYPE } from '@/helpers';
import ProductsSelectSort from '@/components/products/ProductsBlock/ProductsSelectSort/index.vue';
import { mapGetters } from 'vuex';
import ProductsTogglerType from '@/components/products/ProductsBlock/ProductsTogglerType/index.vue';
import ProductsCategorySelect from '@/components/products/ProductsCategoryFilter/ProductCategorySelect';

export default {
  name: 'ProductsSidebarFilters',
  components: {
    ProductsCategorySelect,
    ProductsTogglerType,
    ProductsSelectSort
  },
  props: {
    viewType: {
      type: String,
      default: PRODUCTS_VIEW_TYPE.GRID
    },
    sortTypeDefault: {
      type: [String, null],
      default: null
    }
  },
  emits: ['change-view'],
  data() {
    return {};
  },
  created() {},
  computed: {
    ...mapGetters({
      filters: 'selection/filters'
    })
  },
  methods: {
    onChangeView(type) {
      this.$emit('change-view', type);
    }
  },
  unmounted() {}
};
